import { useState } from 'react';

interface CustomEvent {
  target: {
    type: string;
    name: string;
    value: any;
    checked: boolean;
  };
}

export function useForm<T = any>(initialValues: T) {
  const [values, setValues] = useState<T>(initialValues);

  const handleChange = (event: CustomEvent) => {
    setValues({
      ...values,
      [event.target.name]: event.target.type === 'checkbox' ? event.target.checked : event.target.value,
    });
  };

  const externalSetValues = (newValue: Partial<T>) => {
    setValues({ ...values, ...newValue });
  };

  return [values, handleChange, externalSetValues] as const;
};
